import { Chip, TableCell } from "@mui/material";
import React from "react";
import { FormData } from "../ApplicationData";
import { axiosRequest } from "../../../service/AxiosService";

type Props = {
  row: FormData;
};

/**
 * 申請番号リスト表示コンポーネント
 * - カンマ区切りの申請番号をChipで表示し、クリックで該当申請の詳細画面を開く
 * - props: row (フォームデータ)
 */
const ApplicationNumberList: React.FC<Props> = ({ row }) => {
  const value = row.value?.toString();
  const applicationNumbers: string[] = value
    ? value.split(",").map((num: string) => num.trim()).filter((num: string) => num)
    : [];

  // 申請番号をクリックした際に該当申請の詳細画面を新しいタブで開く
  const handleClick = async (applicationNumber: string) => {
    try {
      const response = await axiosRequest<string>(
        "/applicationGetId",
        "GET",
        { params: { applicationNumber } }
      );

      const applicationId = response;
      if (applicationId) {
        window.open(`/detail/${applicationId}`, "_blank");
      } else {
        alert("該当申請が見つかりません");
      }
    } catch (error) {
      console.error("ID取得エラー:", error);
      alert("申請IDの取得中にエラーが発生しました");
    }
  };

  return (
    <TableCell align="left" sx={{ whiteSpace: "pre-line" }}>
      {applicationNumbers.map((num, index) => (
        <Chip
          key={index}
          label={
            <span style={{ color: "#1976d2", textDecoration: "underline" }}>
              {num}
            </span>
          }
          clickable
          variant="outlined"
          sx={{ cursor: "pointer", mr: 0.5, mb: 0.5 }}
          onClick={() => handleClick(num)}
        />
      ))}
    </TableCell>

  );
};

export default ApplicationNumberList;
